<template>
    <div class="fabu-caigou-page">
        <!-- 顶部Header组件 -->
        <Header />
        <div>
            <!-- 导航路径 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{
                        name: 'home'
                    }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>采购询价</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 主内容区域 -->
            <main class="main-content">
                <div class="container">

                    <!-- 采购商品部分 -->
                    <div class="purchase-goods-section">
                        <div class="section-header">
                            <h2 class="section-title">采购商品</h2>
                            <div class="add-goods-btn" @click="addShop">+ 添加商品</div>
                        </div>

                        <table class="goods-table">
                            <thead>
                                <tr>
                                    <th>商品类别</th>
                                    <th>商品名称</th>
                                    <th>采购数量</th>
                                    <th>可接受采购量误差</th>
                                    <th>平台参考价</th>
                                    <th>当前库存</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in caigouInfo" :key="index">
                                     <td>
                                        <!-- 商品类别：二级分类级联选择器 -->
                                        <el-cascader v-model="item.goods_cascader" :clearable="true"
                                            :options="shop_list" :props="{
                                                value: 'aid',
                                                label: 'name',
                                                children: 'children'
                                            }" placeholder="选择类别" :show-all-levels="false"
                                            @change="handleCategoryChange($event, index)" class="goods-input"></el-cascader>
                                    </td>
                                    <td>
                                        <!-- 商品名称：三级分类级联选择器 -->
                                        <el-cascader v-model="item.goods_cascader_third" :clearable="true"
                                            :options="shop_list_third[index] || []" :props="{
                                                value: 'aid',
                                                label: 'name',
                                                children: 'children'
                                            }" placeholder="选择商品" :show-all-levels="false"
                                            @change="handleProductChange($event, index)" class="goods-input"></el-cascader>
                                    </td>
                                    <td>
                                        <el-input v-model="item.num" placeholder="请输入" class="quantity-input" />
                                        <span class="unit">{{ item.unit }}</span>
                                    </td>
                                    <td>
                                        <el-input v-model="item.error_range" placeholder="请输入" class="error-input" />
                                        <span class="unit">±</span>
                                    </td>
                                    <td>
                                        <span class="price">{{ item.refer_price }}/{{ item.unit }}</span>
                                    </td>
                                    <td>
                                        <span class="stock">{{ item.stock || 0 }}</span>
                                    </td>
                                    <td>
                                        <el-button type="danger" size="small" class="delete-btn"
                                            @click="delItem(index)">删除</el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- 采购信息部分 -->
                    <div class="purchase-info-section">
                        <div class="section-header">
                            <h2 class="section-title">采购信息</h2>
                        </div>

                        <div class="info-form">
                            <div class="form-row">
                                <div class="form-item">
                                    <label>采购标题</label>
                                    <el-input v-model="purchaseInfo.title" placeholder="请填写标题" class="title-input" />
                                </div>
                                <div class="form-item">
                                    <label>结算周期</label>
                                    <el-select v-model="purchaseInfo.settlementPeriod" placeholder="请选择"
                                        class="select-input">
                                        <el-option v-for="item in zhouqi_list" :value="item.value"
                                            :label="item.name"></el-option>

                                    </el-select>
                                </div>
                                <div class="form-item">
                                    <label>一轮比价结束日期</label>
                                    <!-- <el-date-picker v-model="purchaseInfo.endDate" type="datetime" placeholder="请选择"
                                        class="date-picker" value-format="yyyy-MM-DD HH:mm:ss" /> -->

                                    <el-date-picker v-model="purchaseInfo.endDate" type="datetime" placeholder="请选择"
                                        class="date-picker" value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-item full-width">
                                    <label>采购要求</label>
                                    <el-input v-model="purchaseInfo.requirements" type="textarea" :rows="4"
                                        placeholder="请填写您的采购要求" class="textarea-input" />
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- 收货地址 -->

                    <div class="address-info-section">
                        <ShippingAddress :addresses="addresses" :selectedAddressIndex="selectedAddressIndex"
                            @selectAddress="selectAddress" @setAddressFn="setAddressFn"
                            @addressListUpdated="getAddressList" />

                    </div>

                    <!-- 发票信息 -->

                    <div class="address-info-section">
                        <ShippingFapiao :fapiaoList="fapiaoList" :selectedFapiaoIndex="selectedFapiaoIndex"
                            @selectFapiao="selectFapiao" @setFapiaoFn="setFapiaoFn"
                            @fapiaoListUpdated="getFapiaoList" />
                    </div>


                    <div>
                        <el-button type="primary" size="medium" class="publish-btn"
                            @click="submitPurchaseOrder">发布采购</el-button>
                    </div>

                </div>
            </main>

        </div>



        <!-- 底部Footer组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入Header和Footer组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import ShippingAddress from './components/ShippingAddress.vue'
import ShippingFapiao from './components/ShippingFapiao.vue'

export default {
    name: 'FabuCaigou',
    components: {
        // 注册头部组件
        Header,
        // 注册底部组件
        Footer,
        ShippingAddress,
        ShippingFapiao
    },
    data() {
        return {
            // 商品列表数据
            caigouInfo: [{
                goods_cascader: [],
                goods_cascader_third: [],
                goods_label: "",
                goods_id: '',
                num: '',
                error_range: '3',
                refer_price: '',
                stock: '',
                unit: ''
            }],
            // 采购信息数据
            purchaseInfo: {
                title: '',
                settlementPeriod: '',
                endDate: '',
                requirements: ''
            },
            zhouqi_list: [{
                name: '现结',
                value: 1
            }, {
                name: '周结',
                value: 2
            }, {
                name: '月结',
                value: 3
            }, {
                name: '季度结',
                value: 4
            },],

            shop_list: [],
            shop_list_third: [],
            selectedValue: [],
            nowTimeLabel: '',

            //地址
            addresses: [],
            selectedAddress: '',
            selectedAddressIndex: '',

            // 发票
            fapiaoList: [],
            selectedFapiao: '',
            selectedFapiaoIndex: '',
            is_new: '0',
            aid: ''
        }
    },
    watch: {
        caigouInfo: {
            handler(newVal) {
                if (newVal) {
                    console.log(newVal, 'newVal');
                    // 核心逻辑：提取→过滤空值→拼接
                    const labelStr = newVal
                        // 1. 提取所有goods_label属性（无该属性则为undefined）
                        .map(item => item.goods_label)
                        // 2. 过滤掉空值（undefined、null、空字符串）
                        .filter(label => label)
                        // 3. 拼接成逗号分隔的字符串
                        .join("，"); // 注意：中文逗号，若要英文逗号用 ","
                    this.title = this.nowTimeLabel + '采购' + labelStr
                }
            },
            deep: true
        }
    },
    mounted() {
        this.getAddressList();
        this.getFapiaoList()
        this.getPurchaseCategory()
        this.nowTimeLabel = this.$moment().locale("zh-cn").format("YYYY年MM月DD日");
        this.locationInfo = JSON.parse(localStorage.getItem('locationInfo'));

        // 根据路由参数 aid 判断是否调用采购详情接口
        const aid = this.$route.query.aid;
        this.aid = aid
        if (aid) {
            this.getMyPurchaseDetail(aid);
        }
        this.is_new = this.$route.query.is_new

    },
    methods: {
        // 获取发票列表
        getFapiaoList() {
            this.$api.getFapiaoList().then(res => {
                this.fapiaoList = res || [];
                this.fapiaoList.forEach((item, index) => {
                    if (item.is_default == 1) {
                        this.selectedFapiao = item.aid;
                        this.selectedFapiaoIndex = index;
                    }
                })


            }).catch(err => {
                console.error('获取收货地址列表失败:', err);
                this.$message.error(err);
            })
        },

        // 选择发票
        selectFapiao(fapiao) {
            this.selectedFapiao = fapiao;
        },
        // 设置默认发票
        setFapiaoFn(fapiao) {
            this.getFapiaoList();
            this.selectedFapiao = fapiao.aid;
        },
        // 获取收货地址列表
        getAddressList() {
            this.$api.getAddressList().then(res => {
                this.addresses = res.data || [];
                this.addresses.forEach((item, index) => {
                    if (item.is_default == 1) {
                        this.selectedAddress = item.aid;
                        this.selectedAddressIndex = index;
                    }
                })
            }).catch(err => {
                console.error('获取收货地址列表失败:', err);
                this.$message.error(err);
            })
        },

        // 选择地址
        selectAddress(address) {
            this.selectedAddress = address;
        },
        // 设置默认地址
        setAddressFn(address) {
            this.getAddressList();
            this.selectedAddress = address.aid;
        },

        // 获取采购分类
        getPurchaseCategory() {
            this.$api.getPurchaseCategory().then(res => {
                this.shop_list = res || [];
            }).catch(err => {
                console.error('获取采购分类失败:', err);
                this.$message.error(err);
            })
        },

        // 处理商品类别级联选择器的change事件
        handleCategoryChange(value, index) {
            console.log(value, index, '商品类别级联选择器选中的值');
            const pid = value[0];
            const cid = value[1];
            const parentCategory = this.shop_list.find(item => item.aid == pid);
            const selectedCategory = (parentCategory && parentCategory.children && parentCategory.children.find(child => child.aid == cid)) || {};

            this.$set(this.caigouInfo[index], 'goods_cascader_third', []);
            this.caigouInfo[index].goods_label = '';
            this.caigouInfo[index].goods_id = '';
            this.caigouInfo[index].goodscategory_id = cid || '';
            this.caigouInfo[index].refer_price = '';
            this.caigouInfo[index].unit = selectedCategory.unit || '斤';

            if (cid) {
                this.getThirdCategoryData(cid, index);
            } else {
                this.$set(this.shop_list_third, index, []);
            }
        },

        // 获取三级分类数据
        getThirdCategoryData(goodscategory_id, index) {
            this.$api.getThirdCategory({ goodscategory_id }).then(res => {
                const thirdData = (res && res.data) ? res.data : (res || []);
                this.$set(this.shop_list_third, index, thirdData);
            }).catch(err => {
                console.error('获取三级分类失败:', err);
                this.$set(this.shop_list_third, index, []);
            });
        },

        // 处理商品名称级联选择器的change事件
        handleProductChange(value, index) {
            console.log(value, index, '商品名称级联选择器选中的值');
            const productId = Array.isArray(value) ? value[value.length - 1] : value;
            const productList = this.shop_list_third[index] || [];
            const selectedProduct = productList.find(item => item.aid == productId) || {};

            this.caigouInfo[index].goods_label = selectedProduct.name || '';
            this.caigouInfo[index].goods_id = selectedProduct.aid || '';
            this.caigouInfo[index].refer_price = selectedProduct.refer_price || '';
            this.caigouInfo[index].unit = selectedProduct.unit || this.caigouInfo[index].unit || '斤';

            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const dateStr = `${year}年${month}月${day}日`;
            const goodsNames = this.caigouInfo.map(item => item.goods_label).filter(Boolean);
            const goodsStr = goodsNames.join('，');
            this.purchaseInfo.title = goodsStr ? `${dateStr}采购${goodsStr}` : '';
        },

        // 添加商品
        addShop() {
            this.caigouInfo.push({
                goods_cascader: [],
                goods_cascader_third: [],
                goods_label: "",
                goods_id: '',
                goodscategory_id:'',
                num: '',
                error_range: '3',
                refer_price: '',
                stock: '',
                unit: ''
            })
        },
        // 删除指定index的商品
        delItem(index) {
            this.caigouInfo.splice(index, 1)
            
            // 删除后重新生成采购标题
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const dateStr = `${year}年${month}月${day}日`;
            
            // 获取所有商品名称
            const goodsNames = this.caigouInfo.map(item => item.goods_label).filter(Boolean);
            const goodsStr = goodsNames.join('，');
            
            this.purchaseInfo.title = goodsStr ? `${dateStr}采购${goodsStr}` : '';
        },

        // 校验数组每一项的必填字段
        validateForm() {
            // 1. 校验采购商品列表
            for (let i = 0; i < this.caigouInfo.length; i++) {
                const item = this.caigouInfo[i];
                const index = i + 1;

                // 商品选择
                if (!item.goods_id) {
                    this.$message.warning(`请选择第 ${index} 项的商品`);
                    return false;
                }

                // 数量校验（必填且为正整数）
                if (!item.num) {
                    this.$message.warning(`请填写第 ${index} 项的数量`);
                    return false;
                } else if (!/^\d+$/.test(item.num)) {
                    this.$message.warning(`第 ${index} 项的数量必须为正整数`);
                    return false;
                } else if (parseInt(item.num) <= 0) {
                    this.$message.warning(`第 ${index} 项的数量必须大于0`);
                    return false;
                }

                // 误差范围校验（必填且为非负整数）
                if (item.error_range === undefined || item.error_range === null || item.error_range === '') {
                    this.$message.warning(`请填写第 ${index} 项的误差范围`);
                    return false;
                } else if (!/^\d+$/.test(item.error_range)) {
                    this.$message.warning(`第 ${index} 项的误差范围必须为非负整数`);
                    return false;
                }
            }

            // 2. 校验采购基本信息
            if (!this.purchaseInfo.title) {
                this.$message.warning('请填写采购订单标题');
                return false;
            }

            if (!this.purchaseInfo.settlementPeriod) {
                this.$message.warning('请选择采购订单结算周期');
                return false;
            }

            if (!this.purchaseInfo.endDate) {
                this.$message.warning('请选择采购订单截止日期');
                return false;
            }

            if (!this.purchaseInfo.requirements) {
                this.$message.warning('请填写采购订单需求');
                return false;
            }

            // 3. 校验地址和发票
            if (!this.selectedAddress) {
                this.$message.warning('请选择收货地址');
                return false;
            }

            if (!this.selectedFapiao) {
                this.$message.warning('请选择发票抬头');
                return false;
            }

            return true; // 所有校验通过
        },


        // 提交采购订单
        submitPurchaseOrder() {

            if (!this.validateForm()) {
                return; // 校验失败，不提交
            }

            let data = {
                aid: this.aid,
                goods_info: JSON.stringify(this.caigouInfo),
                title: this.purchaseInfo.title,
                needs: this.purchaseInfo.requirements,
                settle_type: this.purchaseInfo.settlementPeriod,
                query_end_date: this.purchaseInfo.endDate,
                lat: this.locationInfo ? this.locationInfo.lat : '',
                lng: this.locationInfo ? this.locationInfo.lng : '',
                useraddress_id: this.selectedAddress,
                userinvoiceheader_id: this.selectedFapiao,
                is_readd: this.is_new,
                // region_code: this.cityCode
            }
            // console.log(data);

            this.$dapi.submitPurchaseOrder(data).then(() => {

                if (this.aid) {
                    // 修改成功返回上一页
                    this.$router.back();
                } else {
                    this.$router.replace({ name: 'FabuSuccess' });
                }


                // 清空表单数据
                this.purchaseInfo = {
                    title: '',
                    settlementPeriod: '',
                    endDate: '',
                    requirements: ''
                };
                this.caigouInfo = [
                    {
                        goods_cascader: [],
                        goods_cascader_third: [],
                        goods_label: "",
                        goods_id: '',
                        num: '',
                        error_range: '3',
                        refer_price: '',
                        stock: '',
                        unit: ''
                    }
                ];

            }).catch(err => {
                console.error('采购订单提交失败:', err);
                this.$message.error(err);
            })
        },

        // 获取采购详情
        getMyPurchaseDetail(aid) {
            this.$api.getMyPurchaseDetail({ aid }).then(res => {
                if (res) {
                    // 这里可以根据返回的数据设置表单字段
                    const purchaseData = res;
                    // 示例：设置商品信息
                    this.caigouInfo = []
                    if (purchaseData.goods_list && Array.isArray(purchaseData.goods_list)) {
                        purchaseData.goods_list.forEach(item => {
                            this.caigouInfo.push({
                                goods_cascader: [item.parent_category_id, item.goods_category_id],
                                goods_cascader_third: [],
                                goods_label: item.name || '',
                                goods_id: item.goods_category_id || '',
                                num: item.num || '',
                                error_range: item.error_range || '3',
                                refer_price: item.refer_price || '',
                                stock: item.stock || '',
                                unit: item.unit || ''
                            })
                        })
                    }
                    // 示例：设置采购信息
                    this.purchaseInfo = {
                        title: purchaseData.title || '',
                        settlementPeriod: purchaseData.settle_type || '',
                        endDate: purchaseData.query_end_date ? new Date(purchaseData.query_end_date) : '',
                        requirements: purchaseData.needs || ''
                    };

                    // 示例：设置地址和发票
                    if (purchaseData.address_info && purchaseData.address_info.aid) {
                        this.selectedAddress = purchaseData.address_info.aid;
                        console.log(this.selectedAddress, 'selectedAddress');

                        if (this.addresses && Array.isArray(this.addresses)) {
                            this.addresses.forEach((item, index) => {
                                if (item.aid == this.selectedAddress) {
                                    this.selectedAddressIndex = index;
                                    console.log(index, 'index');
                                    return;
                                }
                            })
                        }
                        // console.log(this.selectedAddressIndex, 'selectedAddressIndex');
                    }
                    if (purchaseData.invoice_info && purchaseData.invoice_info.aid) {
                        this.selectedFapiao = purchaseData.invoice_info.aid;
                        if (this.fapiaoList && Array.isArray(this.fapiaoList)) {
                            this.fapiaoList.forEach((item, index) => {
                                if (item.aid == this.selectedFapiao) {
                                    this.selectedFapiaoIndex = index;
                                    return;
                                }
                            })
                        }
                        // console.log(this.selectedFapiaoIndex, 'selectedFapiaoIndex');
                    }
                }
            }).catch(err => {
                console.error('获取采购详情失败:', err);
                // this.$message.error('获取采购详情失败');
            })
        }
    }
}
</script>

<style scoped>
.breadcrumb {
    padding: 24px 0 20px 0;
    width: 1200px;
    margin: 0 auto;
}

.fabu-caigou-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;

}

.main-content {
    flex: 1;
    background-color: #f5f5f5;
    padding: 20px 0;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.purchase-goods-section {
    background-color: #fff;
    padding: 24px;
}

.address-info-section {
    margin-top: 30px;
}

.purchase-info-section {
    background-color: #fff;
    padding: 24px
}

.page-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    padding-left: 10px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #EEEEEE;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    padding-left: 10px;
    border-left: 3px solid #286CED;
}

.add-goods-btn {
    color: #286CED;
}

.add-goods-btn:hover {
    cursor: pointer;
}

/* 采购商品表格样式 */
.goods-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    margin-top: 24px;
}

.goods-table th,
.goods-table td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid #e6e6e6;
}

.goods-table th {
    background-color: #fafafa;
    font-weight: bold;
    color: #333;
}

.goods-input {
    width: 150px;
}

.quantity-input,
.error-input {
    width: 80px;
}

.unit {
    margin-left: 5px;
    color: #666;
}

.price,
.stock {
    color: #666;
}

.delete-btn {
    padding: 3px 8px;
    font-size: 12px;
    color: #999999;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #BFBFBF;
    padding: 6px 16px;
}

/* 采购信息表单样式 */
.purchase-info-section {
    margin-top: 30px;
}

.info-form {
    background-color: #fff;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    margin-top: 24px;
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.form-item {
    flex: 1;
    margin-right: 20px;
    min-width: 200px;
    text-align: left;
}

.form-item:last-child {
    margin-right: 0;
}

.form-item.full-width {
    flex: 100%;
}

.form-item label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #333;
}

.title-input {
    width: 100%;
}

.select-input {
    width: 100%;
}

.date-picker {
    width: 100%;
}

.textarea-input {
    width: 100%;
    resize: vertical;
}

.publish-btn {
    width: 240px;
    height: 48px;
    background: #286CED;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    border: none;
    cursor: pointer;
}
</style>